module.exports = __webpack_public_path__ + "img/smile.96a6eba9.png";